export const DEFAULT_THEME_ID = 'vibrant-sage-rose';

export const THEME_IDS = Object.freeze([
  DEFAULT_THEME_ID,
  'warm-brown-cream',
  'cool-blue-coral',
  'vibrant-sage-rose-dark',
  'warm-brown-cream-dark',
  'cool-blue-coral-dark',
]);

/** Swatches for system settings theme picker (matches theme-variables.css) */
export const THEME_PREVIEW_SWATCHES = Object.freeze({
  [DEFAULT_THEME_ID]: {
    primary: '#5fa67d',
    secondary: '#e8758f',
    accent: '#ff9b6a',
  },
  'warm-brown-cream': {
    primary: '#c4872c',
    secondary: '#d79899',
    accent: '#cf8f34',
  },
  'cool-blue-coral': {
    primary: '#5f8196',
    secondary: '#a898c8',
    accent: '#ecc1c5',
  },
  'vibrant-sage-rose-dark': {
    primary: '#72b892',
    secondary: '#a67f8e',
    accent: '#cfa088',
  },
  'warm-brown-cream-dark': {
    primary: '#dcb365',
    secondary: '#e09fa0',
    accent: '#daa04a',
  },
  'cool-blue-coral-dark': {
    primary: '#82a8bd',
    secondary: '#cfb5e8',
    accent: '#ebc5c9',
  },
});

/** Shown in charts; aligns with palettes in CSS theme-variables for each theme */
export const THEME_CHART_COLORS = {
  'vibrant-sage-rose': ['#5fa67d', '#e8758f', '#ff9b6a', '#4d8a67', '#a8d5ba', '#221407', '#8d7a6b'],
  'warm-brown-cream': ['#c4872c', '#4f371c', '#8d7550', '#a06d22', '#d9a85c', '#5c4a31', '#c9944a'],
  'cool-blue-coral': [
    '#5f8196',
    '#a898c8',
    '#ecc1c5',
    '#305472',
    '#b5a9d4',
    '#8b719e',
    '#7fa6bb',
  ],
  'vibrant-sage-rose-dark': [
    '#72b892',
    '#a67f8e',
    '#cfa088',
    '#5a9e78',
    '#8bcaa4',
    '#ececea',
    '#858d87',
  ],
  'warm-brown-cream-dark': [
    '#dcb365',
    '#e09fa0',
    '#daa04a',
    '#bf9448',
    '#e5c982',
    '#f0ebe3',
    '#948979',
  ],
  'cool-blue-coral-dark': [
    '#82a8bd',
    '#cfb5e8',
    '#ebc5c9',
    '#5d85a3',
    '#b89dcf',
    '#9bbcd0',
    '#afb6c9',
  ],
};

export function getChartColors(themeId = DEFAULT_THEME_ID) {
  return THEME_CHART_COLORS[themeId] ?? THEME_CHART_COLORS[DEFAULT_THEME_ID];
}
